import { PaginationRequest } from '../config/common';

export class PaginationPostcodeRequest extends PaginationRequest {
    zonePrefix?: string = '';
    zone?: number;
    packageBoxZone?: number;
}

export interface CreatePostcodeRequest {
    zonePrefix?: string ;
    zone?: number;
    packageBoxZone?: number;
}
